/**
 * Default spatial values for areas with unknown coordinates
 * Using (-999, -999) which is outside valid coordinate ranges
 * (latitude: -90 to 90, longitude: -180 to 180)
 */
export const SPATIAL_CONSTANTS = {
	/**
	 * Default centroid point for areas with unknown coordinates
	 */
	UNKNOWN_CENTROID: 'POINT(-999 -999)',

	/**
	 * Default polygon for areas with unknown coordinates
	 * Creates a small square around the unknown centroid point
	 */
	UNKNOWN_POLYGON:
		'POLYGON((-999 -999, -999 -998.999, -998.999 -998.999, -998.999 -999, -999 -999))',
} as const;
